import script from "./discount_management.vue?vue&type=script&setup=true&lang=js"
export * from "./discount_management.vue?vue&type=script&setup=true&lang=js"

import "./discount_management.vue?vue&type=style&index=0&id=2bf2576f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf2576f"]])

export default __exports__